import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RULES_ACTION_TYPE } from '../actions';

const initialState = {};

const rulesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case RULES_ACTION_TYPE.GET_RULES:
        return payload;

      case RULES_ACTION_TYPE.ADD_CLONED_RULES:
      case RULES_ACTION_TYPE.CLONE_RULE_HIERARCHICALLY:
        payload.forEach(rule => {
          draft[rule.id] = rule;
        });
        break;

      case RULES_ACTION_TYPE.GET_RULE_BY_ID:
      case RULES_ACTION_TYPE.ADD_RULE:
      case RULES_ACTION_TYPE.EDIT_RULE:
      case RULES_ACTION_TYPE.CLONE_RULE:
        draft[payload.id] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default rulesReducer;
